// extracted by mini-css-extract-plugin
module.exports = {"content":"KeyValueLabel_content__1jhi2","key":"KeyValueLabel_key__M9K2l","value":"KeyValueLabel_value__3dJfK"};